import { SxStyles } from 'types/styles';
import { basicTheme } from 'theme';

const baseButtonStyles = {
  display: 'flex',
  height: '40px',
  padding: '8px 24px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  borderRadius: '4px',
  transition: 'all 0.2s ease-in-out',
};

const disabledStyle = {
  opacity: 0.3,
};

export const styles: SxStyles = {
  text: {
    ...baseButtonStyles,
    '&:hover': {
      backgroundColor: basicTheme.palette.mainPalette.lightGrey,
    },
  },

  primary: {
    ...baseButtonStyles,
    backgroundColor: basicTheme.palette.mainPalette.primary,
    color: basicTheme.palette.mainPalette.white,
    '&:hover': {
      backgroundColor: basicTheme.palette.mainPalette.primaryDark,
    },
    '&:active': {
      backgroundColor: basicTheme.palette.mainPalette.primary,
    },
    '&.Mui-disabled': {
      ...disabledStyle,
      backgroundColor: basicTheme.palette.mainPalette.primary,
      color: basicTheme.palette.mainPalette.white,
    },
  },
  outlined: {
    ...baseButtonStyles,
    backgroundColor: 'transparent',
    border: '1px solid',
    borderColor: basicTheme.palette.mainPalette.primary,
    color: basicTheme.palette.mainPalette.primary,
    '&:hover': {
      borderColor: basicTheme.palette.mainPalette.primaryDark,
    },
    '&:active': {
      borderColor: basicTheme.palette.mainPalette.primary,
    },
    '&.Mui-disabled': {
      ...disabledStyle,
      backgroundColor: 'transparent',
      borderColor: basicTheme.palette.mainPalette.primary,
      color: basicTheme.palette.mainPalette.primary,
    },
  },
  alert: {
    ...baseButtonStyles,
    backgroundColor: 'transparent',
    border: '1px solid',
    borderColor: basicTheme.palette.systemPalette.red,
    color: basicTheme.palette.systemPalette.red,
    '&:hover': {
      backgroundColor: basicTheme.palette.systemPalette.red,
      color: basicTheme.palette.mainPalette.white,
    },
    '&:active': {
      borderColor: basicTheme.palette.systemPalette.red,
    },
    '&.Mui-disabled': {
      ...disabledStyle,
      borderColor: basicTheme.palette.systemPalette.red,
      backgroundColor: 'transparent',
      color: basicTheme.palette.systemPalette.red,
    },
  },

  alertFilled: {
    ...baseButtonStyles,
    backgroundColor: basicTheme.palette.systemPalette.red,
    color: basicTheme.palette.mainPalette.white,
    '&:hover': {
      backgroundColor: basicTheme.palette.systemPalette.red,
    },
    '&:active': {
      backgroundColor: basicTheme.palette.systemPalette.red,
    },
    '&.Mui-disabled': {
      ...disabledStyle,
      backgroundColor: basicTheme.palette.systemPalette.red,
      color: basicTheme.palette.mainPalette.white,
    },
  },

  access: {
    ...baseButtonStyles,
    backgroundColor: 'transparent',
    border: '1px solid',
    borderColor: basicTheme.palette.mainPalette.access,
    color: basicTheme.palette.mainPalette.access,
    '&:hover': {
      backgroundColor: basicTheme.palette.mainPalette.access,
      color: basicTheme.palette.mainPalette.white,
    },
    '&:active': {
      borderColor: basicTheme.palette.mainPalette.access,
    },
    '&.Mui-disabled': {
      ...disabledStyle,
      borderColor: basicTheme.palette.mainPalette.access,
      backgroundColor: 'transparent',
      color: basicTheme.palette.mainPalette.access,
    },
  },
  mult: {
    ...baseButtonStyles,
    backgroundColor: 'transparent',
    border: '1px solid',
    borderColor: basicTheme.palette.mainPalette.mult50,
    color: basicTheme.palette.mainPalette.dark,
    '&:hover': {
      backgroundColor: basicTheme.palette.mainPalette.disabled,
      borderColor: basicTheme.palette.mainPalette.disabled,
    },
    '&:active': {
      borderColor: basicTheme.palette.mainPalette.mult50,
    },
    '&.Mui-disabled': {
      ...disabledStyle,
      borderColor: basicTheme.palette.mainPalette.mult50,
      color: basicTheme.palette.mainPalette.dark,
      backgroundColor: 'transparent',
    },
  },
};
